
























import Vue from 'vue'
import Component from 'vue-class-component'

@Component
export default class RemoveConfirmModal extends Vue {
  
  private template: any = {}

  private show = false

  open(template: any) {
    this.template = template
    this.show = true
  }

  close() {
    this.show = false
    this.template = {}
  }

  private confirm() {
    this.$emit('confirm', this.template)
    this.close()
  }
}
